import axiosInstance from "../../lib/axiosInstance"

// Action types
export const FETCH_SUPPORT_REQUEST = "FETCH_SUPPORT_REQUEST"
export const FETCH_SUPPORT_SUCCESS = "FETCH_SUPPORT_SUCCESS"
export const FETCH_SUPPORT_FAILURE = "FETCH_SUPPORT_FAILURE"

// 🔹 Decode Base64 helper
const decodeBase64 = (str) => {
  try {
    return str ? atob(str) : ""
  } catch {
    return str || ""
  }
}

// ✅ Fetch support data (GET)
export const fetchSupport = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SUPPORT_REQUEST })
    try {
      const response = await axiosInstance.get(
        `/api/helpSupport?dbOperation=GET`,
      )

      // 🔹 Decode Base64 content from API response
      const decodedData = Array.isArray(response.data)
        ? response.data.map((item) => ({
            ...item,
            content: decodeBase64(item.content),
          }))
        : []

      dispatch({ type: FETCH_SUPPORT_SUCCESS, payload: decodedData })
      return decodedData // ✅ Ensure Promise resolution
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch support"
      dispatch({ type: FETCH_SUPPORT_FAILURE, payload: message })
      throw new Error(message) // ✅ Reject properly
    }
  }
}
